import { useToggleAppFavoriteMutation } from '@app/services';
import {
    AccessAction,
    AppProject,
    AppProjectClone,
    useAppDispatch,
    useAppProjectAbility,
    useAppSelector,
    useAppUri,
    withAuthHandoff,
} from '@common';
import { selectAuthToken } from '@pages/Authentication/store';
import { setEditAppName, setEditDrawerOpen } from '@pages/MainDashBoard/store';
import React from 'react';

export default function useAppCard(item: AppProject) {
    const dispatch = useAppDispatch();
    const appUri = useAppUri(item?.name);
    const authToken = useAppSelector(selectAuthToken);
    const [toggleAppFavorite] = useToggleAppFavoriteMutation();
    const ability = useAppProjectAbility();

    const canEdit = ability?.can?.(AccessAction.UPDATE, new AppProjectClone(item) as any) || false;

    function handleAppFavorite(event: React.MouseEvent) {
        event.stopPropagation();
        toggleAppFavorite(item?._id);
    }

    function goToApp(event: React.MouseEvent) {
        event.stopPropagation();
        window.open(withAuthHandoff(appUri, authToken), '_blank');
    }
    function handleEditDrawerOpen(event: React.MouseEvent) {
        event.stopPropagation();
        dispatch(setEditAppName(item.name));
        dispatch(setEditDrawerOpen(true));
    }

    return { goToApp, appUri, handleEditDrawerOpen, authToken, handleAppFavorite, canEdit };
}
